import React, {useContext, useEffect, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import FamilySection from './FamilySection'
import {FamilyContext} from '../../Context/FamilyHeadContext'
import {API_URL} from '../../services/apiService'
import {useTranslation} from "react-i18next";
import useSWR from "swr";
import {formatNameAncestor} from "../../utils/personUtils";

const FamilyIndex = () => {
    const navigate = useNavigate()
    const [familyData, setFamilyData] = useState({})
    const [loading, setLoading] = useState(true)
    // const [error, setError] = useState(null)
    const [expandedFamily, setExpandedFamily] = useState(null)
    const {t, i18n} = useTranslation()

    // שליפת מידע על ראש המשפחה מהקונטקסט
    const {
        currentFamilyHead,
        loading: headLoading,
        error: headError,
        isMainSite,
        pathPrefix,
    } = useContext(FamilyContext)

    // עם עליית הקומפוננטה, נטען את רשימת האנשים הקשורים ל־currentFamilyHead
    const {data, error} = useSWR(
        `${API_URL}/indexFamily/${currentFamilyHead.gedId}/${i18n['language']}/${isMainSite}`
    )
    useEffect(() => {
        if (!data && !error) {
            setLoading(true)
        } else {
            setLoading(false)
        }
        if (data) {
            setFamilyData(data)
        }
        if (error?.response?.status === 404) {
            return navigate(`${pathPrefix}404`)
        }
    }, [data, error, i18n.language, currentFamilyHead.gedId, isMainSite])

    // פונקציה שתופעל בלחיצה על אדם
    const handlePersonClick = async (gedId) => {
        navigate(`${pathPrefix}person/${gedId}`)
    }

    // בדיקות טעינה/שגיאה ו־head
    if (loading || headLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-blue-500"></div>
            </div>
        )
    }
    if (error || headError) {
        return (
            <div className="text-red-600 text-center p-4">{error?.message || headError}</div>
        )
    }
    if (!currentFamilyHead) {
        return <div className="text-center p-4"> {t('familyIndex.noFamilyHead')}</div>
    }

    // הצגת האינדקס
    const totalFamilies = Object.keys(familyData).length;
    const familyTitle = `${t('familyIndex.title')} ${formatNameAncestor(currentFamilyHead, i18n["language"])} (${totalFamilies} ${t('familyIndex.totalFamilies')})`

    return (
        <div className="max-w-4xl mx-auto p-4 font-heebo scroll-smooth">
            <h1 className="text-2xl font-bold text-[#4a3f30] mb-6 text-center">
                {familyTitle}
            </h1>

            {/* עיבוד לכל שם משפחה (מפתח באובייקט) */}
            <div className="space-y-4">
                {Object.entries(familyData).map(([familyName, members]) => (
                    <FamilySection
                        key={familyName}
                        familyName={familyName}
                        members={members}
                        isExpanded={expandedFamily === familyName}
                        onToggle={() =>
                            setExpandedFamily(
                                expandedFamily === familyName ? null : familyName,
                            )
                        }
                        onPersonClick={handlePersonClick}
                    />
                ))}
            </div>
        </div>
    )
}

export default FamilyIndex



